/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const ApiTempo = axios.create({ baseURL: 'https://apitempo.inmet.gov.br' });

export default ApiTempo;
